import React from 'react'
import PropTypes from 'prop-types'
import { ContextHeadline } from '@aok/text-elements'

import defaultProps from '../../../utils/propTypes/defaultProps'

import ModuleContainer from '../../_layout/Module/ModuleContainer'

const Y009 = ({ headline, text, className }) => {
  return (
    <ModuleContainer dataTrackingName="Y009" className={className}>
      <div className="grid grid-cols-4 gap-16 600:grid-cols-8 720:gap-x-24 840:grid-cols-12 1000:gap-x-32">
        {headline && (
          <ContextHeadline
            {...headline}
            className="
              col-span-4 600:col-start-2 600:col-end-8 840:col-start-3 840:col-end-11
              text-28 leading-36 text-005e3f font-semibold font-buenos-aires
              1280:text-32 1280:leading-44
            "
          />
        )}

        <div
          className="textBlock col-span-4 600:col-start-2 600:col-end-8 840:col-start-3 840:col-end-11"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </ModuleContainer>
  )
}

Y009.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    tag: PropTypes.string,
  }),
  text: PropTypes.string,
}

Y009.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  text: defaultProps.TEXT,
}

export default Y009
